export default __webpack_public_path__ + "static/media/greeting card.dd208f70.svg";